<template>
    <div class="ma-4">
      <v-row dense v-if="page == 'Main'">
        <v-col cols="12" xl="12">
          <v-card>
            <v-tabs v-model="tab">
              <v-tabs-slider color="yellow"></v-tabs-slider>
              <v-tab
                v-for="(item, i) in items"
                :key="item"
                @click="onChangeTab(i)"
              >
                {{ item }}
              </v-tab>
            </v-tabs>
  
            <v-tabs-items v-model="tab">
              <v-tab-item v-for="(item, i) in items" :key="item">
                <template>
                  <v-card class="pa-2" outlined tile height="100%">
                    <v-data-table
                      :headers="headers"
                      :items="
                        i === 0
                          ? incompleteAttendances
                          : attendances
                      "
                      sort-by="Date"
                      sort-desc
                      :loading="isLoading"
                      loading-text="Loading Client Transportation"
                      :search="search"
                      height="550"
                      item-key="_id"
                      v-model="selectedAttendances"
                      :show-select="i === 0"
                    >
                      <template v-slot:top>
                        <v-toolbar flat color="white">
                          <v-toolbar-title
                            ><span class="text-caption text-sm-body-1"
                              >{{
                                i === 0
                                  ? "Need to be Dropped Off"
                                  : "Completed"
                              }}
                            </span></v-toolbar-title
                          >
                          <v-divider class="mx-4" inset vertical></v-divider>
                          <v-spacer></v-spacer>
                          <v-text-field
                            v-model="search"
                            clearable
                            flat
                            solo-inverted
                            hide-details
                            prepend-inner-icon="search"
                            label="search"
                            class="desktop"
                          ></v-text-field>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="#2b3990" 
                            dark 
                            class="mb-2" 
                            @click="showAdd()"
                          >
                          <v-icon left>add</v-icon>
                                New Entry
                          </v-btn>
                          <v-btn
                            color="green darken-2"
                            class="mb-2"
                            @click="bulkUpdateDropOffTime()"
                            :disabled="selectedAttendances.length === 0"
                            >
                            Apply Drop Off Time
                          </v-btn>
                        </v-toolbar>
                        <v-text-field
                          v-model="search"
                          clearable
                          flat
                          solo-inverted
                          hide-details
                          prepend-inner-icon="search"
                          label="search"
                          class="mobile ml-5 mr-5 mb-3 mt-3"
                        ></v-text-field>
                      </template>

                      <template v-slot:item.TimeEnd="{ item }" v-if="i === 0">
                        <v-select
                        v-model="item.TimeEnd"
                        :items="times"
                        label="Drop Off Time"
                        item-text="Time"
                        item-value="Value"
                        :disabled="!selectedAttendances.includes(item)"
                        />
                    </template>
  
                      <template v-slot:item.actions="{ item }">
                        <v-icon
                          small
                          class="mr-2 hidden-sm-and-down"
                          @click="viewAttendance(item)"
                        >
                          mdi-eye
                        </v-icon>
  
                        <v-btn
                          medium
                          outlined
                          class="mr-4 hidden-md-and-up"
                          color="light-blue darken-4"
                          @click="viewAttendance(item)"
                        >
                          view
                        </v-btn>
  
                        <v-icon
                          v-if="i != 1 && !isAuditorRole"
                          small
                          class="hidden-sm-and-down"
                          @click="attendanceDelete(item)"
                        >
                          mdi-delete
                        </v-icon>
  
                        <v-btn
                          v-if="i != 1 && !isAuditorRole"
                          medium
                          outlined
                          class="hidden-md-and-up red--text"
                          @click="attendanceDelete(item)"
                        >
                          delete
                        </v-btn>
                      </template>
                      <template v-slot:no-data>
                        <v-btn
                          color="#2b3990"
                          class="white--text"
                          @click="getAttendance()"
                          >Reset</v-btn
                        >
                      </template>
                    </v-data-table>
                  </v-card>
                </template>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-if="page == 'Dialog'">
        <v-col cols="12">
            <v-card>
                <v-card-title style="background-color: #2b3990">
                    <span class="headline white--text">{{ titleForm }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form
                            ref="form"
                            lazy-validation
                        >
                            <v-row>
                                <v-col cols="12" sm="12" md="3" v-if="createAttendance == false">
                                    <v-text-field
                                        v-model="clientID"
                                        label="Client"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="3" v-if="createAttendance == true">
                                    <v-select
                                        label="Select a Program"
                                        v-model="newProgram"
                                        :items="programs"
                                        item-value="Name"
                                        item-text="Name"
                                        @change="getClients()"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" v-if="createAttendance == true">
                                    <v-select
                                        label="Select Clients"
                                        v-model="newClients"
                                        :items="clients"
                                        item-value="_id"
                                        item-text="Name"
                                        multiple
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                    <v-menu
                                        ref="menu"
                                        v-model="menu"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="newDate"
                                                label="Date"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="newDate"
                                            no-title
                                            scrollable
                                        >
                                            
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                    <v-text-field
                                        label="Service Code"
                                        v-model="newCode"
                                        :rules="requiredRules"
                                        readonly
                                        disabled
                                    >
                                        <!-- <template v-slot:append-item>
                                            <v-divider class="mb-2"></v-divider>
                                            <v-btn
                                                class="ma-2 white--text"
                                                color="success"
                                                @click="showCodeDialog()"
                                            >
                                                Add Code
                                            </v-btn>
                                        </template> -->
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        v-model="newTitle"
                                        label="Service Code Title"
                                        disabled
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                    <v-text-field
                                        v-model="newUnits"
                                        label="Units"
                                        :readonly="readonly"
                                        :disabled="disabled"
                                        :rules="requiredRules"
                                    ></v-text-field>
                                </v-col>
                                
                                <v-col cols="12" sm="12" md="6">
                                    <v-select
                                        v-model="timeStart"
                                        label="Pick Up Time"
                                        prepend-icon="mdi-clock-time-four-outline"
                                        :items="times"
                                        item-text="Time"
                                        item-value="Value"

                                    ></v-select>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        label="Pick Up Location"
                                        v-model="newPickUpLocation"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                    <v-select
                                        v-model="timeEnd"
                                        label="Drop Off Time"
                                        prepend-icon="mdi-clock-time-four-outline"
                                        :items="times"
                                        item-text="Time"
                                        item-value="Value"
                                    ></v-select>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        label="Drop Off Location"
                                        v-model="newDropOffLocation"
                                    ></v-text-field>
                                </v-col>

                                <v-col class="d-flex" cols="12" sm="12">
                                    <v-checkbox
                                        @click="addSignature()"
                                        label="Signature"
                                        v-model="checkSignature"
                                        class="mr-4"
                                    ></v-checkbox>
                                    <v-text-field 
                                        v-if="signed === true" 
                                        v-model="newSignature"  
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        small
                        @click="showPrintModal()"
                        class="mr-8 mb-2 white--text"
                        color="#2b6993"
                        elevation="4"
                        v-if="!createAttendance"
                    >
                        <v-icon>print</v-icon>
                    </v-btn>
                    <v-btn class="white--text" color="#259647" @click="addAttendance()"
                            v-if="createAttendance && !isAuditorRole">Save
                    </v-btn>
                    <v-btn class="white--text" color="#259647" @click="updateAttendance()"
                            v-if="!createAttendance && !isAuditorRole">Update
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
      </v-row>
  
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  const url = require("../../client_config/config").url;
  import moment from 'moment'
  import {displaySuccess, displayError} from "@/service/notification-message.service";
  import PrintUtil from "../../../utils/print-util";


  
  export default {
    props: {},
    components: {

    },
    data: function () {
      return {
        headers: [
          {
            text: "Date",
            align: "start",
            sortable: false,
            value: "Date",
          },
          { text: "Client", value: "ClientID.Name" },
          { text: "Pick Up Time", value: "TimeStart" },
          { text: "Pick Up Location", value: "PickUpLocation" },
          { text: "Drop Off Time", value: "TimeEnd" },
          { text: "Drop Off Location", value: "Drop Off Location" },
          { text: "Actions", value: "actions", sortable: false },
        ],
        page: 'Main',
        selectedTab: null,
        selectedAttendances: [],
        tab: null,
        search: "",
        items: ["Incomplete", "Complete"],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        msg: false,
        snackbarColor: "black",
        text: "",
        attendances: [],
        incompleteAttendances: [],
        attendance: {},
        codes: [],
        users: [],
        clients: [],
        programs: [],
        clientID: "",
        token: localStorage.getItem('token'),
        userID: localStorage.getItem('userID'),
        staff: localStorage.getItem('Name'),
        tempData: [],
        titleForm: "New Transportation Entry",
        attendanceID: "",
        newClients: [],
        newName: "",
        newTitle: "Motor Transportation Payment",
        newUnits: "1",
        newCode: "MTP",
        newDate: "",
        newSignature: "",
        Rate: "",
        signed: false,
        checkSignature: false,
        //newUnits: "",
        newServiceUnit: "Daily",
        newPickUpLocation: "",
        newDropOffLocation: "",
        editedIndex: -1,
        editedItem: {
            name: "",
            code: "",
            date: "",
            signature: "",
            unit: "",
            serviceUnit: "",
        },
        defaultItem: {
            name: "",
            code: "",
            date: "",
            signature: "",
            unit: "",
            serviceUnit: "",
        },
        isLoading: true,
        requiredRules: [
            v => !!v || 'This is required',
        ],
        timeStartPicker: false,
        timeStart: "",
        timeEndPicker: false,
        timeEnd: "",
        timeEndAdjust: null,
        requiredTime: false,
        newServiceCodeDialog: false,
        newServiceCodeAdd: "",
        maskDate: [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        maskTimeStart: [/[1]/, /\d/, ':', /[0-5]/, /\d/, ' ', /[A,P]/, 'M'],
        maskTimeEnd: [/[1]/, /\d/, ':', /[0-5]/, /\d/, ' ', /[A,P]/, 'M'],
        showStartTimePicker: false,
        showEndTimePicker: false,
        timeStartDisplay: '',
        timeEndDisplay: '',
        readonly: true,
        disabled: true,
        client: false,
        createAttendance: false,
        userState: localStorage.getItem('userState'),
        bulkDropOffTime: "",
        newProgram: "",
        times: [
            {Time: "6:00am", Value: "6:00am"}, {Time: "6:15am", Value: "6:15am"}, {
                Time: "6:30am",
                Value: "6:30am"
            }, {Time: "6:45am", Value: "6:45am"},
            {Time: "7:00am", Value: "7:00am"}, {Time: "7:15am", Value: "7:15am"}, {
                Time: "7:30am",
                Value: "7:30am"
            }, {Time: "7:45am", Value: "7:45am"},
            {Time: "8:00am", Value: "8:00am"}, {Time: "8:15am", Value: "8:15am"}, {
                Time: "8:30am",
                Value: "8:30am"
            }, {Time: "8:45am", Value: "8:45am"},
            {Time: "9:00am", Value: "9:00am"}, {Time: "9:15am", Value: "9:15am"}, {
                Time: "9:30am",
                Value: "9:30am"
            }, {Time: "9:45am", Value: "9:45am"},
            {Time: "10:00am", Value: "10:00am"}, {Time: "10:15am", Value: "10:15am"}, {
                Time: "10:30am",
                Value: "10:30am"
            }, {Time: "10:45am", Value: "10:45am"},
            {Time: "11:00am", Value: "11:00am"}, {Time: "11:15am", Value: "11:15am"}, {
                Time: "11:30am",
                Value: "11:30am"
            }, {Time: "11:45am", Value: "11:45am"},
            {Time: "12:00pm", Value: "12:00pm"}, {Time: "12:15pm", Value: "12:15pm"}, {
                Time: "12:30pm",
                Value: "12:30pm"
            }, {Time: "12:45pm", Value: "12:45pm"},
            {Time: "1:00pm", Value: "13:00pm"}, {Time: "1:15pm", Value: "13:15pm"}, {
                Time: "1:30pm",
                Value: "13:30pm"
            }, {Time: "1:45pm", Value: "13:45pm"},
            {Time: "2:00pm", Value: "14:00pm"}, {Time: "2:15pm", Value: "14:15pm"}, {
                Time: "2:30pm",
                Value: "14:30pm"
            }, {Time: "2:45pm", Value: "14:45pm"},
            {Time: "3:00pm", Value: "15:00pm"}, {Time: "3:15pm", Value: "15:15pm"}, {
                Time: "3:30pm",
                Value: "15:30pm"
            }, {Time: "3:45pm", Value: "15:45pm"},
            {Time: "4:00pm", Value: "16:00pm"}, {Time: "4:15pm", Value: "16:15pm"}, {
                Time: "4:30pm",
                Value: "16:30pm"
            }, {Time: "4:45pm", Value: "16:45pm"},
            {Time: "5:00pm", Value: "17:00pm"}, {Time: "5:15pm", Value: "17:15pm"}, {
                Time: "5:30pm",
                Value: "17:30pm"
            }, {Time: "5:45pm", Value: "17:45pm"},
            {Time: "6:00pm", Value: "18:00pm"}, {Time: "6:15pm", Value: "18:15pm"}, {
                Time: "6:30pm",
                Value: "18:30pm"
            }, {Time: "6:45pm", Value: "18:45pm"},
            {Time: "7:00pm", Value: "19:00pm"}, {Time: "7:15pm", Value: "19:15pm"}, {
                Time: "7:30pm",
                Value: "19:30pm"
            }, {Time: "7:45pm", Value: "19:45pm"},
            {Time: "8:00pm", Value: "20:00pm"}, {Time: "8:15pm", Value: "20:15pm"}, {
                Time: "8:30pm",
                Value: "20:30pm"
            }, {Time: "8:45pm", Value: "20:45pm"},
            {Time: "9:00pm", Value: "21:00pm"}, {Time: "9:15pm", Value: "21:15pm"}, {
                Time: "9:30pm",
                Value: "21:30pm"
            }, {Time: "9:45pm", Value: "21:45pm"},
            {Time: "10:00pm", Value: "22:00pm"}, {Time: "10:15pm", Value: "22:15pm"}, {
                Time: "10:30pm",
                Value: "22:30pm"
            }, {Time: "10:45pm", Value: "22:45pm"},
            {Time: "11:00pm", Value: "23:00pm"}, {Time: "11:15pm", Value: "23:15pm"}, {
                Time: "11:30pm",
                Value: "23:30pm"
            }, {Time: "11:45pm", Value: "23:45pm"},

        ],
      };
    },
  
    computed: {
  
      userRole() {
        return this.$store.state.users.user.Role === "Administration";
      },
  
      isAuditorRole() {
        return localStorage.getItem("userRole") === 'Auditor'
      },
  
    },
  
    created() {
      this.getAttendance();
      this.getPrograms();
    },
  
    mounted(){
      this.showActions.add = !this.isAuditorRole;
      window.addEventListener('keydown', async (event) => {
          const downloadUrl = await this.generateDownloadUrl();
          PrintUtil.handleKeydown(event, downloadUrl, this.attendanceID, this.token, 'Transportation');
      });
    },
  
    watch: {
      isAuditorRole(newVal) {
        this.showActions.add = !newVal; 
      }
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.attendanceID, this.token, 'Transportation');
        });
    },

    methods: {
        validate() {
            return this.$refs.form.validate()
        },

        showSelectedItems() {
            console.log(this.selectedAttendances);
        },

        viewAttendance(item) {
            this.titleForm = (typeof item.Title == 'undefined') ? "Viewing attendance " : 'Viewing ' + item.Title;
            this.page = 'Dialog';
            this.createAttendance = false;
            this.clientID = item.ClientID.Name
            this.newName = item.Name;
            this.newCode = item.Code;
            this.newTitle = item.Title;
            this.newDate = item.Date;
            this.timeStartDisplay = moment(item.Date + " " + item.TimeStart).format("hh:mma")
            this.timeEndDisplay = moment(item.Date + " " + item.TimeEnd).format("hh:mma")
            // if(item.ServiceUnit === "Quarter Hour" || item.ServiceUnit === "Session" || item.ServiceUnit === "Hourly"){
            //   this.requiredTime = true;
            //   this.timeStart = item.TimeStart;
            //   this.timeEnd = item.TimeEnd;
            // }
            this.timeStart = item.TimeStart;
            this.timeEnd = item.TimeEnd;
            this.newUnits = item.Units;
            this.newServiceUnit = item.ServiceUnit;
            this.newPickUpLocation = item.PickUpLocation;
            this.newDropOffLocation = item.DropOffLocation;
            this.attendanceID = item._id;
            if (this.newServiceUnit === "Quarter Hour" || this.newServiceUnit === "Session") {
                this.requiredTime = true
            } else {
                this.requiredTime = false;

            }
            if (item.Signature !== "") {
                this.newSignature = item.Signature;
                this.signed = true;
                this.checkSignature = true;
            }
        },

        async addAttendance() {
            for(var i = 0; i < this.newClients.length; i++){

                let payload = {
                    Name: this.newName,
                    Code: this.newCode,
                    Title: this.newTitle,
                    Date: this.newDate,
                    Signature: this.newSignature,
                    ClientID: this.newClients[i],
                    Units: this.newUnits,
                    ServiceUnit: this.newServiceUnit,
                    TimeStart: this.timeStart,
                    TimeEnd: this.timeEnd,
                    Rate: this.Rate,
                    PickUpLocation: this.newPickUpLocation,
                    DropOffLocation: this.newDropOffLocation,
                };

                // Log the payload to verify that all the values are correct
                console.log("Payload for client", this.newClients[i], payload);

                try {
                    const response = await axios.post(`${url}/attendance`, payload)

                    if (response.status !== 200) {
                        displayError("An error occurred while adding the attendance record.")
                        return;
                    }

                    // displaySuccess("The attendance record has been added successfully.")

                } catch (error) {
                    console.log({error});
                } 
            }
            this.getAttendance();
            this.close();

            
        },

        async addAttendanceForClients() {
            for (const client of this.newClients) {
                await this.addAttendance(client);
            }
        },

        async updateAttendance() {

        let req_body = {
            Name: this.newName,
            Code: this.newCode,
            Title: this.newTitle,
            Date: this.newDate,
            Signature: this.newSignature,
            Units: this.newUnits,
            ServiceUnit: this.newServiceUnit,
            TimeStart: this.timeStart,
            TimeEnd: this.timeEnd,
            Rate: this.Rate,
            PickUpLocation: this.newPickUpLocation,
            DropOffLocation: this.newDropOffLocation
        };

        try {
            const response = await axios.put(`${url}/attendance/${this.attendanceID}`, req_body)

            if (response.status !== 200) {
                displayError("An error occurred while updating the attendance record.")
                return;
            }

            displaySuccess("The attendance record has been updated successfully.")
            this.getAttendance();
        } catch (error) {
            console.log({error});
        } finally {
            this.close();
        }
        },
  
      async getAttendance() {
            this.attendances = [];
            this.isLoading = true;
            axios.get(`${url}/attendance/serviceCode/MTP`).then(res => {
                this.attendances = res.data.complete;
                this.incompleteAttendances = res.data.incomplete;

            }).finally(() => this.isLoading = false);
       },

        async attendanceDelete(item) {
            axios.delete(`${url}/attendance/${item._id}`)
                .then((response) => {
                    this.getAttendance();
                    if (response.status == 400) {
                        response.json().then(function (data) {
                            return data.msg;
                        });
                    }
                    this.snackbarColor = "black";
                    this.msg = true;
                    this.text = "The attendance record has been deleted successfully.";
                });
        },

    //     async bulkUpdate() {
    //     if (this.selectedAttendances.length === 0) {
    //     return;
    //     }

    //     // Iterate through the selectedAttendances array and perform an update
    //     const bulkUpdatePayload = this.selectedAttendances.map(item => {
    //     // Adjust the payload as per your backend API requirements
    //     return {
    //         id: item._id, // assuming _id is the unique identifier for attendance
    //         updatedField: 'newValue', // Replace with the actual field and value you want to update
    //     };
    //     });

    //     try {
    //     // Send the bulk update request to the server
    //     await axios.post('/api/attendances/bulk-update', bulkUpdatePayload);

    //     // Display success message
    //     this.$notify({
    //         type: 'success',
    //         text: `${this.selectedAttendances.length} items have been updated successfully.`,
    //     });

    //     // Clear the selection after the update
    //     this.selectedAttendances = [];

    //     // Optionally reload the attendances data
    //     this.getAttendance();

    //     } catch (error) {
    //     console.error(error);
    //     this.$notify({
    //         type: 'error',
    //         text: 'An error occurred during the update.',
    //     });
    //     }
    // },

    bulkApplyDropOffTime() {
    if (!this.bulkDropOffTime) {
      displayError('Please select a drop-off time.');
      return;
    }
    console.log(this.selectedAttendances)
    // Apply the selected bulk drop-off time to each selected attendance
    this.selectedAttendances.forEach(item => {
      item.TimeEnd = this.bulkDropOffTime;
    });
    
    // Optionally, you can send this to the backend in bulk
    // this.bulkUpdateDropOffTime();
  },

  async bulkUpdateDropOffTime() {
    try {
      const bulkUpdatePayload = this.selectedAttendances.map(item => ({
        id: item._id, 
        TimeEnd: item.TimeEnd,
      }));

      await axios.post(`${url}/attendance/bulk-update`, bulkUpdatePayload);

      displaySuccess('Drop Off Time updated for selected items.');

      this.selectedAttendances = [];
      this.getAttendance();  // Refresh data if needed

    } catch (error) {
      console.error(error);
      displayError('An error occurred during the update.');
    }
  },

        async getClients() {
            await axios.get(`${url}/clients/userProgram/${this.userState}?userProgram=${this.newProgram}`)
                .then((res) => {
                    this.clients = res.data.clients;
                });
        },

        async getPrograms() {
            await axios.get(`${url}/units/state/${this.userState}`)
                .then((res) => {
                    this.programs = res.data.units;
                });
        },

        addSignature: function () {
            if (this.signed === false) {
                this.newSignature = this.staff + " - " + new Date();
                this.signed = true;
            } else {
                this.newSignature = "";
                this.signed = false;
            }
        },

        close() {
            this.page = 'Main'
            this.createAttendance = false;
            this.resetForm();
        },

        showAdd() {
            this.page = 'Dialog'
            this.createAttendance = true;
        },

        resetForm() {
            this.newName = "";
            this.newCode = "";
            this.newDate = "";
            this.newSignature = "";
            this.newUnits = "";
            this.newServiceUnit = "";
            this.signed = false;
            this.timeStart = "";
            this.timeEnd = "";
            this.newPickUpLocation = "";
            this.newDropOffLocation = "";
        },

  
      onChangeTab(item) {
        this.incoming = item === 0 ? false : true;
      },   

      async generateDownloadUrl() {
          return `${url}/attendance/print?id=${this.attendanceID}`;
      },

      async showPrintModal() {
          const downloadUrl = await this.generateDownloadUrl();
          PrintUtil.showPrintOption(downloadUrl, this.attendanceID, this.token, 'Transportation');
      },
  
    },
  };
  </script>
  <style>
  @media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }
  
  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }
  }
  </style>
  